/**
 * PKCE (Proof Key for Code Exchange) utilities for OAuth2 (RFC 7636).
 */

export function generateCodeVerifier(): string {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return base64UrlEncode(array);
}

export async function generateCodeChallenge(verifier: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return base64UrlEncode(new Uint8Array(digest));
}

function base64UrlEncode(array: Uint8Array): string {
  return btoa(String.fromCharCode(...array))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

export function generateState(): string {
  const array = new Uint8Array(16);
  crypto.getRandomValues(array);
  return base64UrlEncode(array);
}

export function storePkceParams(verifier: string, state: string): void {
  sessionStorage.setItem('pkce_verifier', verifier);
  sessionStorage.setItem('pkce_state', state);
}

export function getPkceParams(): { verifier: string | null; state: string | null } {
  return {
    verifier: sessionStorage.getItem('pkce_verifier'),
    state: sessionStorage.getItem('pkce_state'),
  };
}

export function clearPkceParams(): void {
  sessionStorage.removeItem('pkce_verifier');
  sessionStorage.removeItem('pkce_state');
}
